var loading = "Loading";
var change = "Change";
var edit = "Edit";
var logout = "Logout";
var support = "Marigold Help Center";
var more = "More";
var yes = "Yes";
var no = "No";
var exit = "Exit";
var you = "You";
var search = "Search";
var ok = "Ok";
var en = {
	loading: loading,
	change: change,
	"no-application-available": "No application available.",
	"change-business-unit": "Change Business Unit",
	"select-a-business-unit-to-change": "Select a business unit to change to. If the business unit does not utilize your current application, you will be taken to your Profile.",
	"business-unit": "Business Unit",
	edit: edit,
	logout: logout,
	support: support,
	"ces-administration": "Marigold ID Administration",
	"system-administration": "System Administration",
	more: more,
	yes: yes,
	no: no,
	"you-already-switched-to": "You already switched to <bold>{{name}}</bold> a while ago. Do you want to switch <bold>{{name}}</bold> here?",
	"business-unit-has-changed": "Business Unit has changed",
	exit: exit,
	you: you,
	"impersonated-user": "Impersonated User",
	"no-business-unit-assigned": "No business unit assigned",
	"explore-marigold": "Explore Marigold",
	"no-data-to-display": "No data to display",
	search: search,
	ok: ok,
	"impersonated-session-ended": "Impersonation Session Ended",
	"impersonated-session-ended-description": "Your impersonation session has ended."
};

export { change, en as default, edit, exit, loading, logout, more, no, ok, search, support, yes, you };
